if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Add event listener for color changes
        this.form.querySelectorAll('input[name="Color"]').forEach((color) => {
          color.addEventListener('change', (event) => {
            const selectedColor = event.target.value;
            this.updateAvailableSizes(selectedColor); // Call the function to update sizes
          });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // Function to update available sizes based on the selected color
   updateAvailableSizes(selectedColor) {
    const sizeSelectors = this.form.querySelectorAll('input[name="Size"]'); 

    sizeSelectors.forEach((size) => {
        const sizeValue = size.value;
        const isAvailable = this.checkAvailability(selectedColor, sizeValue);

        // Log the size, color, and availability status to check what happens
        console.log(`Checking size: ${sizeValue} for color: ${selectedColor} - Available: ${isAvailable}`);

        const label = this.form.querySelector(`label[for="${size.id}"]`);

        if (label) {
            console.log(`Found label for size: ${sizeValue}`);

            if (isAvailable) {
                size.disabled = false; // Enable the input
                label.classList.remove('disabled'); // Remove disabled class from the label
                console.log(`Removed 'disabled' from label for size: ${sizeValue}`);
            } else {
                size.disabled = true; // Disable the input
                label.classList.add('disabled'); // Add disabled class to the label
                console.log(`Added 'disabled' to label for size: ${sizeValue}`);
            }
        } else {
            console.error(`Label not found for size: ${sizeValue}`);
        }
    });
}



      // Function to check if a specific size is available for the selected color
      checkAvailability(selectedColor, selectedSize) {
        const availableVariants = [
          { color: 'Red', size: 'S' },
          { color: 'Red', size: 'M' },
          { color: 'Blue', size: 'M' },
          { color: 'Blue', size: 'L' }
          // Add your available color-size combinations here
        ];

        // Check if the selected color-size combination exists in the availableVariants array
        return availableVariants.some(variant => variant.color === selectedColor && variant.size === selectedSize);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
